import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-description-non-final',
		defaultMessage: `Your Opsgenie actions and incident rules aren't automatically moved to Jira Service Management.\n
You can easily recreate them using Jira Automation's vast library of rule templates and components. [Read how to recreate Opsgenie actions and rules with Jira automation](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)
`,
		description:
			'Transition home automate your alert and incident response step task two description',
	},
	taskOneButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-button-non-final',
		defaultMessage: 'Go to Jira automation',
		description: 'Transition home automate your alert and incident response step task one button',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-description-non-final',
		defaultMessage: `To avoid conflict between Opsgenie and Jira, delete your teams' Opsgenie actions and incident rules in Opsgenie. It's recommended to do this after setting up your automation in Jira.\n
In your Opsgenie team, select **Actions** and **Incident rules** and delete all the action channels, actions, and incident rules permanently. [Read how to delete Opsgenie actions and incidents rules](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)
`,
		description:
			'Transition home automate your alert and incident response step task two description',
	},
	taskTwoButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-button-non-final',
		defaultMessage: 'Go to teams in Opsgenie',
		description: 'Transition home automate your alert and incident response step task two button',
	},
});
